<template>
  <div class="container-fluid p-4 shadow-sm rounded">

    <!-- ENCABEZADO -->
    <div class="card mb-4">
      <div class="card-header bg-warning text-dark fw-bold py-1 d-flex justify-content-between align-items-center">
        <span>Nota de Crédito</span>
        <span v-if="secuencial" class="small fw-normal">{{ secuencial }}</span>
      </div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Emisión</label>
            <input type="date" class="form-control form-control-sm" v-model="cabecera.fechaEmision" />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Punto Emisión</label>
            <select class="form-select form-select-sm" v-model="cabecera.puntoEmisionId" :disabled="cargandoPuntos">
              <option v-if="cargandoPuntos" disabled value="">Cargando...</option>
              <option v-else-if="puntosEmision.length === 0" disabled value="">Sin puntos</option>
              <option v-for="p in puntosEmision" :key="p.id" :value="p.id">{{ p.full_code }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Ambiente</label>
            <input type="text" class="form-control form-control-sm" v-model="cabecera.ambiente" disabled />
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Secuencial</label>
            <input type="text" class="form-control form-control-sm" v-model="secuencial" disabled />
          </div>
        </div>
      </div>
    </div>

    <!-- FACTURA MODIFICADA -->
    <div class="card mb-4">
      <div class="card-header bg-warning text-dark fw-bold py-1">Documento Modificado</div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-4">
            <label class="form-label small mb-1">Número de Factura <span class="text-danger">*</span></label>
            <div class="input-group input-group-sm">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Ej: 001-001-000000001"
                v-model="docModificado.numero"
                @blur="buscarFactura"
                @keyup.enter="buscarFactura"
              />
              <button class="btn btn-outline-secondary btn-sm" @click="buscarFactura" :disabled="buscandoFactura">
                <span v-if="buscandoFactura" class="spinner-border spinner-border-sm"></span>
                <span v-else>🔍</span>
              </button>
            </div>
            <div v-if="facturaEncontrada" class="text-success small mt-1">✅ Factura encontrada</div>
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Fecha Emisión Doc. Modificado <span class="text-danger">*</span></label>
            <input type="date" class="form-control form-control-sm" v-model="docModificado.fechaEmision" />
          </div>
          <div class="col-md-5">
            <label class="form-label small mb-1">Motivo de la Nota de Crédito <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-sm" v-model="motivo" placeholder="Ej: Devolución de mercancía, error en precio..." />
          </div>
        </div>
      </div>
    </div>

    <!-- DATOS DEL COMPRADOR -->
    <div class="card mb-4">
      <div class="card-header bg-warning text-dark fw-bold py-1">Datos del Comprador</div>
      <div class="card-body py-2">
        <div class="row gy-2">
          <div class="col-md-3">
            <label class="form-label small mb-1">Tipo Identificación</label>
            <select class="form-select form-select-sm" v-model="comprador.tipoIdentificacion">
              <option value="04">RUC</option>
              <option value="05">Cédula</option>
              <option value="06">Pasaporte</option>
              <option value="07">Consumidor Final</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label small mb-1">Identificación</label>
            <input type="text" class="form-control form-control-sm" v-model="comprador.identificacion" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Razón Social</label>
            <input type="text" class="form-control form-control-sm" v-model="comprador.razonSocial" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Correo</label>
            <input type="email" class="form-control form-control-sm" v-model="comprador.correo" />
          </div>
          <div class="col-md-6">
            <label class="form-label small mb-1">Dirección</label>
            <input type="text" class="form-control form-control-sm" v-model="comprador.direccion" />
          </div>
        </div>
      </div>
    </div>

    <!-- DETALLES DE LA NC -->
    <div class="card mb-4">
      <div class="card-header bg-warning text-dark fw-bold py-1">Detalles de la Nota de Crédito</div>
      <div class="card-body py-2">
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead class="table-light">
              <tr>
                <th>Código</th>
                <th style="min-width:200px">Descripción</th>
                <th style="width:90px">Precio Unit.</th>
                <th style="width:80px">Cant.</th>
                <th style="width:80px">Descuento</th>
                <th style="width:80px">IVA %</th>
                <th style="width:90px">Subtotal</th>
                <th style="width:60px">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in detalles" :key="idx">
                <td><input type="text" class="form-control form-control-sm" v-model="item.codigo" /></td>
                <td><input type="text" class="form-control form-control-sm" v-model="item.descripcion" /></td>
                <td><input type="number" class="form-control form-control-sm text-end" v-model.number="item.precioUnitario" @input="calcularLinea(item)" min="0" step="0.01" /></td>
                <td><input type="number" class="form-control form-control-sm text-end" v-model.number="item.cantidad" @input="calcularLinea(item)" min="0.01" step="0.01" /></td>
                <td><input type="number" class="form-control form-control-sm text-end" v-model.number="item.descuento" @input="calcularLinea(item)" min="0" step="0.01" /></td>
                <td>
                  <select class="form-select form-select-sm" v-model.number="item.porcentajeIVA" @change="calcularLinea(item)">
                    <option :value="15">15%</option>
                    <option :value="5">5%</option>
                    <option :value="0">0%</option>
                  </select>
                </td>
                <td class="text-end fw-semibold">{{ item.subtotal.toFixed(2) }}</td>
                <td class="text-center"><button class="btn btn-outline-danger btn-sm" @click="eliminarDetalle(idx)">🗑️</button></td>
              </tr>
              <tr v-if="detalles.length === 0">
                <td colspan="8" class="text-center text-muted fst-italic small">Sin detalles.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button class="btn btn-outline-warning btn-sm" @click="agregarDetalle">+ Agregar ítem</button>
      </div>
    </div>

    <!-- TOTALES -->
    <div class="row justify-content-end mb-4">
      <div class="col-md-4">
        <div class="card border-warning">
          <div class="card-body py-2">
            <div class="d-flex justify-content-between small">
              <span>Subtotal sin IVA:</span>
              <span>$ {{ totales.subtotalSinIva.toFixed(2) }}</span>
            </div>
            <div class="d-flex justify-content-between small">
              <span>Descuento total:</span>
              <span>$ {{ totales.descuentoTotal.toFixed(2) }}</span>
            </div>
            <div class="d-flex justify-content-between small">
              <span>IVA:</span>
              <span>$ {{ totales.iva.toFixed(2) }}</span>
            </div>
            <hr class="my-1">
            <div class="d-flex justify-content-between fw-bold">
              <span>Total:</span>
              <span>$ {{ totales.total.toFixed(2) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ACCIONES -->
    <div class="d-flex gap-2 justify-content-end">
      <router-link to="/ventas/documentos-emitidos" class="btn btn-outline-secondary">Cancelar</router-link>
      <button class="btn btn-outline-warning" @click="guardar(false)" :disabled="procesando">
        <span v-if="procesando" class="spinner-border spinner-border-sm me-1"></span>
        Guardar Borrador
      </button>
      <button class="btn btn-warning text-dark fw-semibold" @click="guardar(true)" :disabled="procesando">
        <span v-if="procesando" class="spinner-border spinner-border-sm me-1"></span>
        Emitir Nota de Crédito
      </button>
    </div>

    <!-- ALERTA -->
    <div v-if="alerta.mensaje" :class="`alert alert-${alerta.tipo} mt-3`" role="alert">
      {{ alerta.mensaje }}
    </div>

  </div>
</template>

<script>
import api from '@/services/api'
import { mapGetters } from 'vuex'

function hoy() {
  const now = new Date()
  const ec = new Date(now.getTime() + -5 * 60 * 60 * 1000)
  return ec.toISOString().slice(0, 10)
}

export default {
  name: 'ClientNotaCredito',

  data() {
    return {
      cabecera: {
        fechaEmision: hoy(),
        puntoEmisionId: '',
        ambiente: '',
      },
      secuencial: '000000001',
      puntosEmision: [],
      cargandoPuntos: false,

      docModificado: {
        numero: '',
        fechaEmision: hoy(),
        facturaId: null,
      },
      facturaEncontrada: false,
      buscandoFactura: false,
      motivo: '',

      comprador: {
        tipoIdentificacion: '04',
        identificacion: '',
        razonSocial: '',
        correo: '',
        direccion: '',
      },

      detalles: [],
      procesando: false,
      alerta: { mensaje: '', tipo: 'danger' },
    }
  },

  computed: {
    ...mapGetters(['currentUser']),
    totales() {
      const subtotalSinIva = this.detalles.reduce((s, d) => s + (d.subtotalSinIva || 0), 0)
      const descuentoTotal = this.detalles.reduce((s, d) => s + (d.descuento || 0), 0)
      const iva = this.detalles.reduce((s, d) => s + (d.iva || 0), 0)
      return {
        subtotalSinIva,
        descuentoTotal,
        iva,
        total: subtotalSinIva + iva,
      }
    },
  },

  async mounted() {
    await Promise.all([this.cargarPuntosEmision(), this.cargarAmbiente()])
    this.agregarDetalle()
  },

  methods: {
    async cargarPuntosEmision() {
      this.cargandoPuntos = true
      try {
        const { data } = await api.get('/configuracion/puntos-emision')
        this.puntosEmision = data.data || []
        if (this.puntosEmision.length > 0) {
          this.cabecera.puntoEmisionId = this.puntosEmision[0].id
        }
      } catch (e) {
        console.error('Error al cargar puntos de emisión:', e)
      } finally {
        this.cargandoPuntos = false
      }
    },

    async cargarAmbiente() {
      try {
        const { data } = await api.get('/configuracion/ambiente-sri')
        if (data.success && data.data) {
          this.cabecera.ambiente = data.data.nombre
        }
      } catch (e) {
        console.error('Error al cargar ambiente:', e)
      }
    },

    async buscarFactura() {
      const numero = this.docModificado.numero.trim()
      if (!numero) return
      this.buscandoFactura = true
      this.facturaEncontrada = false
      try {
        const { data } = await api.get('/facturas', {
          params: { numero_comprobante: numero, limit: 1 }
        })
        const facturas = data.data || []
        if (facturas.length > 0) {
          const f = facturas[0]
          this.facturaEncontrada = true
          this.docModificado.facturaId = f.id
          this.docModificado.fechaEmision = f.fecha_emision?.slice(0, 10) || hoy()
          // Llenar datos del comprador desde la factura
          this.comprador.identificacion = f.identificacion_comprador || ''
          this.comprador.razonSocial = f.razon_social_comprador || ''
          this.comprador.correo = f.correo_comprador || ''
          this.comprador.tipoIdentificacion = f.tipo_identificacion || '04'
        } else {
          this.alerta = { mensaje: 'No se encontró la factura con ese número.', tipo: 'warning' }
        }
      } catch (e) {
        console.error('Error al buscar factura:', e)
      } finally {
        this.buscandoFactura = false
      }
    },

    agregarDetalle() {
      this.detalles.push({
        codigo: '',
        descripcion: '',
        precioUnitario: 0,
        cantidad: 1,
        descuento: 0,
        porcentajeIVA: 15,
        subtotalSinIva: 0,
        iva: 0,
        subtotal: 0,
      })
    },

    eliminarDetalle(idx) {
      this.detalles.splice(idx, 1)
    },

    calcularLinea(item) {
      const base = (item.precioUnitario * item.cantidad) - item.descuento
      item.subtotalSinIva = base < 0 ? 0 : base
      item.iva = item.subtotalSinIva * (item.porcentajeIVA / 100)
      item.subtotal = item.subtotalSinIva + item.iva
    },

    validar() {
      if (!this.docModificado.numero.trim()) return 'Ingrese el número de la factura a modificar.'
      if (!this.cabecera.puntoEmisionId) return 'Seleccione un punto de emisión.'
      if (!this.motivo.trim()) return 'Ingrese el motivo de la nota de crédito.'
      if (!this.comprador.identificacion.trim()) return 'Ingrese la identificación del comprador.'
      if (!this.comprador.razonSocial.trim()) return 'Ingrese la razón social del comprador.'
      if (this.detalles.length === 0) return 'Agregue al menos un detalle.'
      for (const d of this.detalles) {
        if (!d.descripcion.trim()) return 'Complete la descripción de todos los detalles.'
      }
      return null
    },

    async guardar(emitir) {
      this.alerta = { mensaje: '', tipo: 'danger' }
      const error = this.validar()
      if (error) {
        this.alerta = { mensaje: error, tipo: 'warning' }
        return
      }

      this.procesando = true
      try {
        const payload = {
          intent: emitir ? 'ISSUE' : 'DRAFT',
          punto_emision_id: this.cabecera.puntoEmisionId,
          fecha_emision: this.cabecera.fechaEmision,
          factura_id: this.docModificado.facturaId || null,
          numero_doc_modificado: this.docModificado.numero,
          fecha_emision_doc_modificado: this.docModificado.fechaEmision,
          motivo: this.motivo,
          tipo_identificacion: this.comprador.tipoIdentificacion,
          identificacion_comprador: this.comprador.identificacion,
          razon_social_comprador: this.comprador.razonSocial,
          correo_comprador: this.comprador.correo || null,
          direccion_comprador: this.comprador.direccion || null,
          detalles: this.detalles.map(d => ({
            codigo_principal: d.codigo,
            descripcion: d.descripcion,
            precio_unitario_subsidiado: d.precioUnitario,
            cantidad: d.cantidad,
            descuento: d.descuento,
            porcentaje_iva: d.porcentajeIVA,
          })),
        }

        const { data } = await api.post('/notas-credito', payload)
        if (data.success) {
          this.alerta = { mensaje: emitir ? 'Nota de crédito emitida correctamente.' : 'Borrador guardado correctamente.', tipo: 'success' }
          setTimeout(() => this.$router.push('/ventas/documentos-emitidos'), 1500)
        } else {
          this.alerta = { mensaje: data.error || 'Error al procesar la nota de crédito.', tipo: 'danger' }
        }
      } catch (e) {
        this.alerta = { mensaje: e.response?.data?.error || 'Error al conectar con el servidor.', tipo: 'danger' }
      } finally {
        this.procesando = false
      }
    },
  },
}
</script>
